/* 布局 */
//前台
import Layout from "@views/layout";

const questionoptiontemplateRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "questionoptiontemplate",
            name: "QUESTIONOPTIONTEMPLATE",
            meta: {
                title: "",
                sort: 1,
            },
            component: () => import("@views/business/questionoptiontemplate/index.vue"),
            redirect: {
                name: "QUESTIONOPTIONTEMPLATE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "QUESTIONOPTIONTEMPLATE_LIST",
                    meta: {
                        title: "",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/questionoptiontemplate/list.vue"),
                },
                                {
                    path: "add",
                    name: "QUESTIONOPTIONTEMPLATE_ADD",
                    meta: {
                        title: "新增问卷模板选项表",
                        parentPath: '/business/questionoptiontemplate/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionoptiontemplate/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "QUESTIONOPTIONTEMPLATE_EDIT",
                    meta: {
                        title: "编辑问卷模板选项表",
                        parentPath: '/business/questionoptiontemplate/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionoptiontemplate/form.vue"),
                },
                                        ],
    },


        ],
};

export default questionoptiontemplateRouter;
